!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, s = t.parcelRequire5f74;
  null == s && ((s = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var s = i[t];
      delete i[t];
      var r = {
        id: t,
        exports: {}
      };
      return e[t] = r, s.call(r.exports, r, r.exports), r.exports;
    }
    var a = new Error("Cannot find module '" + t + "'");
    throw a.code = "MODULE_NOT_FOUND", a;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = s), (0, s.register)("kmbQD", function(t, e) {
    var i, s, r, a;
    i = t.exports, s = "default", r = function() {
      return o;
    }, Object.defineProperty(i, s, {
      get: r,
      set: a,
      enumerable: !0,
      configurable: !0
    });
    class o {
      static _activeRequests=new Map;
      static _fetch(t, e = {}, i = null) {
        if (i) {
          this._activeRequests.has(i) && this._activeRequests.get(i).abort();
          const t = new AbortController;
          this._activeRequests.set(i, t), e.signal = t.signal;
        }
        return fetch(t, e).then(t => (i && this._activeRequests.delete(i), t)).catch(t => {
          throw i && "AbortError" !== t.name && this._activeRequests.delete(i), t;
        });
      }
      static doChange({id: t, quantity: e, properties: i = {}}, s = !1) {
        const r = `change-${t}`;
        return this._fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...i
            }
          })
        }, r).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && s && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, i = !1) {
        const s = `update-${JSON.stringify(t)}`, r = Array.isArray(t) ? t.reduce((t, i) => ({
          ...t,
          [i]: e
        }), {}) : {
          id: e
        };
        return this._fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: r
          })
        }, s).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && i && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: i = {}}, s = !1) {
        const r = `add-${t}`;
        return this._fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...i
              }
            } ]
          })
        }, r).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && s ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return this._fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }, "get-cart").then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static updateForm(t, e = !1) {
        return this._fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: t
        }, "update-form").then(t => {
          if (!t.ok) throw new Error("Cart form update failed");
          return e && this.update(!0), t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", i = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("shopping-cart").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const s = document.getElementById("Cart"), r = !!t || s && s.checked;
        return fetch(`${Shopify.routes.root || "/"}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, s] = t, a = (new DOMParser).parseFromString(s, "text/html");
            i ??= [ `[id^="shopify-section-"][id$="${e}"]` ], i.push("[data-header-cart-count]"), 
            i.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const i = a.querySelector(t);
                i && (e.innerHTML = r ? i.innerHTML.replace('id="Cart"', 'id="Cart" checked') : i.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var r = s("kmbQD");
  class a extends HTMLElement {
    constructor() {
      super();
    }
    initialiseElements() {
      if (this.form = this.querySelector("[data-form]"), !this.form) return;
      this.idInput = this.form.querySelector("[data-id]"), this.submit = this.form.querySelector("[data-submit]"), 
      this.submitText = this.form.querySelector("[data-submit-text]"), this.radios = this.querySelectorAll("[data-option-radio]"), 
      this.priceElements = this.querySelectorAll("[data-price]"), this.compareAtPriceElements = this.querySelectorAll("[data-compare-at-price]"), 
      this.priceRanges = this.querySelectorAll("[data-price-range]"), this.priceWrappers = this.querySelectorAll("[data-price-single]"), 
      this.relatedProducts = this.querySelectorAll("[data-related-product-id]"), this.gemstoneInfos = this.querySelectorAll("[data-gemstone-info]"), 
      this.activeGemstoneInfo = Array.from(this.gemstoneInfos).find(t => !t.classList.contains("hidden"));
      const t = this.form.getAttribute("id");
      this.foreignSubmits = t ? document.querySelectorAll(`[form="${t}"]`) : [], this.hasRingSize = "true" === this.form.dataset.hasRingSize, 
      this.ringSizePosition = parseInt(this.form.dataset.ringSizePosition, 10), this.ringSizeSelected = !1;
      new URLSearchParams(window.location.search).has("variant") && (this.ringSizeSelected = !0);
    }
    initialiseData() {
      const t = this.querySelector("[data-product-variants]");
      this.variants = t ? JSON.parse(t.textContent) : [];
    }
    connectedCallback() {
      this.initialiseElements(), this.initialiseData(), this.form && (this.form.addEventListener("submit", this.handleSubmit.bind(this)), 
      this.form.addEventListener("change", t => {
        t.target.matches("[data-option-radio]") && this.handleVariantChange(t);
      }), this.foreignSubmits.forEach(t => t.addEventListener("click", this.handleForeignSubmit.bind(this))), 
      this.radios.length > 0 && this.handleVariantChange(), this.registerGemstoneHoverListeners());
    }
    registerGemstoneHoverListeners() {
      this.relatedProducts.forEach(t => {
        t.addEventListener("mouseenter", () => {
          const e = t.dataset.relatedProductId;
          this.updateGemstoneVisibility(e);
        }), t.addEventListener("mouseleave", () => {
          const t = this.activeGemstoneInfo?.dataset.gemstoneInfo;
          this.updateGemstoneVisibility(t);
        });
      });
    }
    updateGemstoneVisibility(t) {
      t ? this.gemstoneInfos.forEach(e => {
        e.dataset.gemstoneInfo === t ? (e.classList.remove("hidden"), e.classList.add("block")) : (e.classList.add("hidden"), 
        e.classList.remove("block"));
      }) : this.gemstoneInfos.forEach(t => t.classList.add("hidden"));
    }
    getSelectedOptions(t = null) {
      const e = [], i = this.variants.length > 0 ? this.variants[0].options.length : 0;
      for (let t = 0; t < i; t++) e.push(null);
      return this.radios.forEach(i => {
        const s = parseInt(i.name.replace("option", ""), 10) - 1;
        t && t.name === i.name ? t.value === i.value && (e[s] = t.value) : i.checked && (e[s] = i.value);
      }), e;
    }
    handleVariantChange(t = null) {
      const e = t ? t.target : null;
      e && e.name === `option${this.ringSizePosition}` && (this.ringSizeSelected = !0);
      const i = this.getSelectedOptions(e), s = this.findMatchingVariant(i);
      if (s) this.applyVariantUpdates(s); else if (1 === this.variants.length && 0 === this.radios.length) {
        const t = this.variants[0];
        this.applyVariantUpdates(t);
      } else this.idInput.value = "", this.updateSubmitButtons(null);
      this.updateOptionLabels(i), this.updateOptionAvailability(i), this.updateURL(s);
    }
    applyVariantUpdates(t) {
      this.idInput.value = t.id, this.updateSubmitButtons(t), this.updatePrice(t);
    }
    updatePrice(t) {
      this.priceElements.length && void 0 !== t.price && this.priceElements.forEach(e => {
        e.textContent = Shopify.formatMoney(t.price, Shopify.money_format);
      }), this.priceRanges.length && this.priceWrappers.length && (this.priceRanges.forEach(t => t.classList.add("hidden")), 
      this.priceWrappers.forEach(t => t.classList.remove("hidden"))), this.compareAtPriceElements.forEach(e => {
        t.compare_at_price && t.compare_at_price > t.price ? (e.textContent = Shopify.formatMoney(t.compare_at_price, Shopify.money_format), 
        e.classList.remove("hidden")) : e.classList.add("hidden");
      });
    }
    findMatchingVariant(t) {
      return this.variants.find(e => e.options.every((e, i) => e === t[i]));
    }
    updateSubmitButtons(t) {
      const e = t?.available, i = window.settings?.stock_notify;
      let s = !1, r = "";
      const a = window.strings || {};
      this.hasRingSize && !this.ringSizeSelected ? (s = !1, r = a.chooseSize || "Choose your size") : t ? e ? (s = !1, 
      r = a.addToCart || "Add to cart") : i ? (s = !1, r = a.notify || "Notify me") : (s = !0, 
      r = a.soldOut || "Sold out") : (s = !0, r = a.selectOptions || "Select options"), 
      s ? this.submit.setAttribute("data-disabled", "true") : this.submit.removeAttribute("data-disabled"), 
      this.submitText && (this.submitText.textContent = r), this.foreignSubmits.forEach(t => {
        s ? t.setAttribute("data-disabled", "true") : t.removeAttribute("data-disabled");
        const e = t.querySelector("[data-submit-text]");
        e && (e.textContent = r);
      });
    }
    updateOptionLabels(t) {
      t.forEach((t, e) => {
        if (!t) return;
        const i = e + 1, s = this.querySelector(`[data-option-label][data-option-position="${i}"]`);
        if (s) {
          const e = s.dataset.optionName;
          s.textContent = `${e}: ${t}`;
        }
      });
    }
    updateOptionAvailability(t) {
      this.radios.forEach(e => {
        const i = parseInt(e.name.replace("option", "")) - 1, s = e.value;
        this.variants.some(e => !!e.available && (e.options[i] === s && e.options.every((e, s) => s === i || (null === t[s] || t[s] === e)))) ? e.removeAttribute("aria-out-of-stock") : e.setAttribute("aria-out-of-stock", "");
      });
    }
    updateURL(t) {
      if (!t) return;
      const e = new URL(window.location.href);
      e.searchParams.set("variant", t.id), window.history.replaceState({
        path: e.toString()
      }, "", e.toString());
    }
    handleForeignSubmit(t) {
      if (t.preventDefault(), this.hasRingSize && !this.ringSizeSelected) {
        const t = this.querySelector("#product-size-drawer summary");
        return void (t && t.click());
      }
      if (!this.getCurrentVariant()) {
        if (t.currentTarget.closest("#product-size-drawer")) {
          const t = this.querySelector("#product-size-drawer summary");
          t && t.click();
        } else this.form && this.form.scrollIntoView({
          behavior: "smooth"
        });
        return;
      }
      this.form.dispatchEvent(new Event("submit", {
        cancelable: !0,
        bubbles: !0
      }));
    }
    handleSubmit(t) {
      t.preventDefault();
      const e = t.submitter && t.submitter.closest("#product-size-drawer");
      if (!e && this.submit?.hasAttribute("data-disabled")) return;
      if (this.hasRingSize && !this.ringSizeSelected) {
        const t = this.querySelector("#product-size-drawer summary");
        return void (t && t.click());
      }
      const i = this.getCurrentVariant();
      if (i) i.available && this.addToCart(i); else if (e) {
        const t = this.querySelector("#product-size-drawer summary");
        t && t.click();
      }
    }
    getCurrentVariant() {
      const t = this.idInput?.value;
      return t ? this.variants.find(e => e.id === parseInt(t)) : null;
    }
    addToCart(t) {
      this.setSubmitLoadingState();
      const e = new FormData(this.form), i = {};
      e.forEach((t, e) => {
        if (e.startsWith("properties[")) {
          const s = e.match(/\[(.*?)\]/)[1];
          i[s] = t;
        }
      }), r.default.doAdd({
        id: t.id,
        quantity: 1,
        properties: i
      }, !0).then(t => {
        const e = window.strings || {}, i = t.ok ? e.added || "Added" : e.error || "Error";
        this.setSubmitTempState(i);
      }).catch(() => {
        const t = window.strings || {};
        this.setSubmitTempState(t.error || "Error");
      });
    }
    setSubmitLoadingState() {
      const t = window.strings || {};
      this.setButtonState(!0, t.adding || "Adding...");
    }
    setSubmitTempState(t) {
      this.setButtonState(!1, t), setTimeout(() => this.restorePreviousButtonText(), 1e3);
    }
    setButtonState(t, e) {
      t ? this.submit.setAttribute("data-disabled", "true") : this.submit.removeAttribute("data-disabled"), 
      this.submitText && !this.submitText.dataset.previousText && (this.submitText.dataset.previousText = this.submitText.innerHTML), 
      this.submitText && (this.submitText.innerHTML = e), this.foreignSubmits.forEach(t => {
        const i = t.querySelector("[data-submit-text]");
        i && (i.dataset.previousText || (i.dataset.previousText = i.innerHTML), i.innerHTML = e);
      });
    }
    restorePreviousButtonText() {
      this.submitText && this.submitText.dataset.previousText && (this.submitText.innerHTML = this.submitText.dataset.previousText, 
      delete this.submitText.dataset.previousText), this.foreignSubmits.forEach(t => {
        const e = t.querySelector("[data-submit-text]");
        e && e.dataset.previousText && (e.innerHTML = e.dataset.previousText, delete e.dataset.previousText);
      });
    }
  }
  customElements.get("product-form") || customElements.define("product-form", a);
}();